// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import globe02Icon from "@/assets/icons/globe-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Globe02IconProps = Omit<IconProps, "name">;

export function Globe02Icon(props: Globe02IconProps): React.ReactNode {
  return <Icon name={globe02Icon} {...props} />;
}
